import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/resize.svg";
var ResizeSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ResizeSolid_default as default
};
